import React from 'react'
import WriteOffActFormButton from '../form/WriteOffActFormButton'

const WriteOffActOptions = () => {
  return (
    <div>
		<WriteOffActFormButton />
    </div>
  )
}

export default WriteOffActOptions